
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Updated content for the `}<a parentName="p" {...{
        "href": "/patterns"
      }}>{`design pattern pages`}</a>{`, added more components to the PX Blue `}<a parentName="p" {...{
        "href": "https://www.figma.com/community/file/852558784352181868"
      }}>{`Figma sticker sheet`}</a>{`, new Angular components for `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/angular/?path=/info/components-dropdown-toolbar--readme"
      }}>{`Dropdown Toolbar`}</a>{` and `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/angular/?path=/story/components-drawer--with-a-nav-rail"
      }}>{`Navigation Rail`}</a>{`, new React component for `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react/?path=/info/components-dropdown-toolbar--get-read-me-story"
      }}>{`Dropdown Toolbar`}</a>{`, new React Native components for `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--spacer"
      }}>{`Spacer`}</a>{` and `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react-native/?path=/info/components-documentation--list-item-tag"
      }}>{`List Item Tag`}</a>{`, built a re-usable authentication workflow for React.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;